// src/store/index.js
import { createStore } from 'vuex';
import users from './modules/users';
import modals from './modules/modals';
import navigation from './modules/navigation';
import layout from './modules/layout';

export default createStore({
  state: {
    isTheme: "dark"
  },
  getters: {
    theme: state => state.isTheme
  },
  mutations: {
    setTheme(state, theme) {
      state.isTheme = theme;
    }
  },
  actions: {
    initializeTheme({ commit }) {
      const storedTheme = localStorage.getItem('isTheme');
      const theme = storedTheme === 'light' || storedTheme === 'dark' ? storedTheme : 'dark';
      if (!storedTheme) {
        localStorage.setItem('isTheme', theme);
      }
      commit('setTheme', theme);
    },
    changeTheme({ commit }, theme) {
      const next = theme === 'light' ? 'light' : 'dark';
      localStorage.setItem('isTheme', next);
      commit('setTheme', next);
    }
  },
  modules: {
    users,
    modals,
    navigation,
    layout
  }
});
